angular.module('zc.zenclerkS')
  .controller('ZcsInterestWidgetNavigationController', ZcsInterestWidgetNavigationController);

ZcsInterestWidgetNavigationController.$inject = ['project'];
function ZcsInterestWidgetNavigationController(project) {
  const vm = this;

  vm.project = project;
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/interest_widget/interest_widget_navigation.controller.js